import React from 'react';
import config from '../../config';

export default class FormBanco04 extends React.Component{
   
    componentWillMount(){
        window.open(config.printLocalService, '_blank');
    }

    render(){
        return null;
    }
}